module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "flex full-page-header"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('pl-button', {
    staticClass: "header-title",
    nativeOn: {
      "click": function($event) {
        return _vm.backToPrevious.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left mr2"
  }), _vm._v(" "), _c('span', [_vm._v(" Back ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center w-100"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.user.avatar_url,
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-title b ml2"
  }, [_vm._v("\n        " + _vm._s(_vm.user.name) + "\n      ")])])]), _vm._v(" "), _c('fixed-side-bar', {
    staticClass: "student-activity-summary-page absolute",
    attrs: {
      "sizeOfFixedSideInPixels": _vm.display_acitivty_list ? _vm.side_bar_width : 0,
      "navBackgroundColor": "#fcfcfc",
      "bodyBackgroundColor": "white"
    }
  }, [_c('fixed-nav-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.display_acitivty_list),
      expression: "display_acitivty_list"
    }],
    staticClass: "center-xs pl-white-smoke absolute w-100",
    style: (("max-width:" + _vm.side_bar_width + "px")),
    attrs: {
      "slot": "side-nav-slot",
      "heightOfNavInPixels": 75
    },
    slot: "side-nav-slot"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "slot": "nav-slot"
    },
    slot: "nav-slot"
  }, [_c('div', [_c('pl-button', {
    staticClass: "pl-white b ttu",
    nativeOn: {
      "click": function($event) {
        return _vm.exportStudentReport.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/export.svg"
    }
  }), _vm._v("\n            Export Report\n          ")])], 1)]), _vm._v(" "), _c('activities-side-bar', {
    staticClass: "activities-list left-side",
    attrs: {
      "slot": "body-slot",
      "activities": _vm.activities,
      "summarySelected": _vm.type_selected === 'summary'
    },
    on: {
      "summarySelected": function($event) {
        _vm.type_selected = 'summary'
      },
      "activitySelected": _vm.displayActivity
    },
    slot: "body-slot"
  })], 1), _vm._v(" "), _c('fixed-nav-bar', {
    staticClass: "student-activity-body",
    attrs: {
      "slot": "side-body-slot",
      "heightOfNavInPixels": 80
    },
    slot: "side-body-slot"
  }, [_c('div', {
    staticClass: "row no-margin middle-xs",
    staticStyle: {
      "height": "100%",
      "border-bottom": "1px solid #ececec"
    },
    attrs: {
      "slot": "nav-slot"
    },
    slot: "nav-slot"
  }, [_c('div', {
    staticClass: "flex ma3",
    class: {
      'toggle-side-bar': _vm.hovered
    },
    on: {
      "click": function($event) {
        _vm.display_acitivty_list = !_vm.display_acitivty_list
      },
      "mouseenter": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      }
    }
  }, [_c('div', {
    staticClass: "customize-tooltip"
  }, [(!_vm.hovered && _vm.display_acitivty_list) ? _c('img', {
    attrs: {
      "src": "/static/logos/collapse_black.svg",
      "alt": "hide"
    }
  }) : (_vm.hovered && _vm.display_acitivty_list) ? _c('img', {
    attrs: {
      "src": "/static/logos/collapse_blue.svg",
      "alt": "hide"
    }
  }) : (!_vm.hovered && !_vm.display_acitivty_list) ? _c('img', {
    attrs: {
      "src": "/static/logos/expand_black.svg",
      "alt": "hide"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/logos/expand_blue.svg",
      "alt": "hide"
    }
  }), _vm._v(" "), (_vm.hovered) ? _c('div', [_vm._v("\n              " + _vm._s(_vm.display_acitivty_list ? 'collapse' : 'expand') + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "middle-xs truncate-text",
    staticStyle: {
      "width": "85%"
    }
  }, [(_vm.type_selected !== 'summary') ? _c('div', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "white-space": "nowrap",
      "font-size": "24px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selected_activity.title) + "\n              "), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.activity_date) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-primary i ph2",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.jumpToRoundTable
    }
  }, [_vm._v("\n                Jump to RoundTable\n              ")])])]) : _c('div', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "white-space": "nowrap",
      "font-size": "24px"
    }
  }, [_vm._v("\n              Trending Reports\n            ")])])])]), _vm._v(" "), _c('template', {
    slot: "body-slot"
  }, [(_vm.type_selected === 'Live' && !_vm.is_loading) ? _c('ld-measure', {
    staticClass: "individual-activity-summary center-xs",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "100px"
    }
  }) : (_vm.type_selected === 'Online') ? [(_vm.is_loading) ? _c('div', {
    staticClass: "flex justify-center items-center h-100"
  }, [_c('div', {
    key: "loading",
    staticClass: "flex center-xs middle-xs h-inherit"
  }, [_c('p', [_vm._v("Loading RoundTable")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-spinner')], 1)])]) : _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('by-pass-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_by_pass_card),
      expression: "show_by_pass_card"
    }],
    staticStyle: {
      "margin": "20px auto",
      "width": "700px"
    },
    attrs: {
      "submission": _vm.submission,
      "showAssessmentByDefault": true
    }
  }), _vm._v(" "), _c('submission-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_by_pass_card && _vm.submission),
      expression: "!show_by_pass_card && submission"
    }],
    staticStyle: {
      "margin": "20px auto",
      "width": "700px"
    },
    attrs: {
      "submission": _vm.submission,
      "studentActivitySummary": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_by_pass_card && !_vm.submission),
      expression: "!show_by_pass_card && !submission"
    }],
    staticClass: "pl-headline center-xs mt3"
  }, [_vm._v("\n              The student did not submit anything for this RoundTable\n            ")])], 1)] : (_vm.is_loading) ? _c('div', {
    staticClass: "flex justify-center items-center h-100"
  }, [_c('pl-spinner', {
    staticClass: "x2"
  })], 1) : _c('div', {
    staticClass: "student-activity-body-card center-xs"
  }, [(_vm.type_selected === 'summary') ? _c('trending-charts', {
    staticClass: "trending-charts"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show_overlay === 'comment' && _vm.submission_in_overlay) ? _c('individual-comment-overlay', {
    key: "individual-comment-overlay",
    attrs: {
      "submission": _vm.submission_in_overlay
    },
    on: {
      "close": _vm.closeOverlay
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_overlay === 'reply' && _vm.submission_in_overlay) ? _c('individual-reply-overlay', {
    key: "individual-reply-overlay",
    attrs: {
      "submission": _vm.submission_in_overlay
    },
    on: {
      "close": _vm.closeOverlay
    }
  }) : _vm._e()], 2)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7c172d19!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/studentActivitySummary/studentActivitySummary.vue
// module id = 1704
// module chunks = 61